export default {
  enterpriseServers: {
    text: 'Enterprise Servers',
    value: {
      scope: 'enterprise',
      role: 'server',
    },
  },
  enterpriseClients: {
    text: 'Enterprise Clients',
    value: {
      scope: 'enterprise',
      role: 'client',
    },
  },
  internetServers: {
    text: 'Internet Servers',
    value: {
      scope: 'internet',
      role: 'server',
    },
  },
  internetClients: {
    text: 'Internet Clients',
    value: {
      scope: 'internet',
      role: 'client',
    },
  },
  allServers: {
    text: 'All Servers',
    value: {
      scope: 'all',
      role: 'server',
    },
  },
  allClients: {
    text: 'All Clients',
    value: {
      scope: 'all',
      role: 'client',
    },
  },
};
